import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminVerifySecret } from "../../services/adminDataService";

export const AdminLogin = () => {
  const [secret, setSecret] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!secret) return;

    setIsLoading(true);
    setError(null);

    try {
      const isValid = await adminVerifySecret(secret);
      if (isValid) {
        sessionStorage.setItem("admin_token", secret);
        navigate("/admin");
      } else {
        setError("Incorrect admin secret.");
      }
    } catch (err) {
      setError("Failed to verify secret. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-text">
      <div className="bg-card border border-border p-8 rounded-2xl max-w-sm w-full shadow-2xl">
        <h1 className="text-2xl font-bold mb-4 font-['Unbounded'] text-white">Admin Login</h1>
        {error && (
          <div className="mb-4 p-3 bg-red-500/10 border border-red-500/20 text-red-400 text-sm rounded-lg">
            {error}
          </div>
        )}
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label htmlFor="password_xxx" className="block text-sm font-medium mb-1 text-muted">
              Admin Secret
            </label>
            <input
              id="password_xxx"
              type="password"
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              className="w-full bg-background-accent text-text border border-border focus:border-main focus:outline-none p-2.5 rounded-lg transition-all"
              required
              disabled={isLoading}
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-main text-background py-2.5 rounded-lg font-bold hover:opacity-90 hover:shadow-[0_0_10px_rgba(94,207,190,0.4)] disabled:opacity-50 disabled:cursor-not-allowed transition-all cursor-pointer flex justify-center items-center"
          >
            {isLoading ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-background border-t-transparent rounded-full animate-spin"></span>
                Verifying...
              </span>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
